import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { tournament } from "src/api/poker";
import TournamentDetailsCard from "src/components/Poker/Tournaments/TournamentDetailsCard";
import Spinner from "src/components/Spinner";
import Page404 from "src/pages/Page404";

const IndividualTournament = () => {
  const { gid } = useParams();
  const { i18n } = useTranslation();
  const [tournamentData, setTournamentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTournament = async () => {
      if (!gid) {
        setError("Tournament ID is required");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const data = await tournament(gid);

        if (data) {
          setTournamentData(data);
        } else {
          setError("Tournament not found");
        }
      } catch (err) {
        console.error("Error fetching tournament:", err);
        setError(err.message || "Failed to load tournament");
      } finally {
        setLoading(false);
      }
    };

    fetchTournament();
  }, [gid]);

  if (loading) {
    return (
      <LoadingContainer>
        <Spinner />
      </LoadingContainer>
    );
  }

  if (error || !tournamentData) {
    return <Page404 />;
  }

  const tournamentTitle = tournamentData[`name_${i18n.language}`] || tournamentData.name_en;

  return (
    <Container>
      <TournamentCardContainer>
        <TournamentDetailsCard
          title={tournamentTitle}
          tournamentDetails={tournamentData}
          currentLocale={i18n.language}
          structure_file_url={tournamentData[`structure_file_${i18n.language}`]}
          collapseDetails={false}
        />
      </TournamentCardContainer>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background-color: var(--lightblack);
  padding: 2rem 0;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
`;

const TournamentCardContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  /* padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  } */
`;

export default IndividualTournament;
